import "./index.scss";

function Spinner() {
  return <div className="loader"></div>;
}

export default Spinner;
